var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    [
      _vm.bookingComplete
        ? _c(
            "v-card",
            [
              _c(
                "v-list-item",
                { staticClass: "text-center", attrs: { "three-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-icon", { attrs: { size: "64", color: "green" } }, [
                        _vm._v(" sentiment_satisfied_alt ")
                      ]),
                      !_vm.bookingMediated
                        ? _c(
                            "v-list-item-title",
                            { staticClass: "mb-6 display-1 green--text" },
                            [_vm._v("Booking confirmed!")]
                          )
                        : _vm._e(),
                      _vm.bookingMediated
                        ? _c(
                            "v-list-item-title",
                            { staticClass: "mb-6 display-1 green--text" },
                            [_vm._v("Booking awaiting approval")]
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "details" },
                        [
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "title font-weight-black" },
                            [
                              _c("v-icon", { attrs: { size: "35" } }, [
                                _vm._v("schedule")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.formattedDate) +
                                  " " +
                                  _vm._s(_vm.formattedSlot) +
                                  " "
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-list-item-subtitle",
                            { staticClass: "title font-weight-black" },
                            [
                              _c("v-icon", { attrs: { size: "35" } }, [
                                _vm._v("location_on")
                              ]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.asset.name) +
                                  " at " +
                                  _vm._s(_vm.asset.location_name) +
                                  " "
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "v-card-text",
                [
                  _c("div", {
                    domProps: {
                      innerHTML: _vm._s(_vm.category.thank_you_message)
                    }
                  }),
                  _c(
                    "v-list",
                    [
                      _c(
                        "v-list-item",
                        { attrs: { "two-line": "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [_vm._v("Name")]),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pl-3" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(_vm.form.firstName) +
                                      " " +
                                      _vm._s(_vm.form.lastName) +
                                      " "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _c(
                        "v-list-item",
                        { attrs: { "two-line": "" } },
                        [
                          _c(
                            "v-list-item-content",
                            [
                              _c("v-list-item-title", [_vm._v("Email")]),
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "pl-3" },
                                [_vm._v(" " + _vm._s(_vm.form.email) + " ")]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.form.cell
                        ? _c(
                            "v-list-item",
                            { attrs: { "two-line": "" } },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c("v-list-item-title", [_vm._v("Cell #")]),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "pl-3" },
                                    [_vm._v(" " + _vm._s(_vm.form.cell) + " ")]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm.group.custom_fields.fields
                    ? _c(
                        "v-list",
                        _vm._l(_vm.group.custom_fields.fields, function(
                          field,
                          index
                        ) {
                          return _c(
                            "v-list-item",
                            { key: index, attrs: { "two-line": "" } },
                            [
                              _c(
                                "v-list-item-content",
                                [
                                  _c(
                                    "v-list-item-title",
                                    { staticClass: "custom-field-question" },
                                    [_vm._v(_vm._s(field.title))]
                                  ),
                                  _c(
                                    "v-list-item-subtitle",
                                    { staticClass: "pl-3" },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            field.type !== "checkbox"
                                              ? _vm.form[field.name]
                                              : _vm.form[field.name]
                                              ? "Yes"
                                              : "No"
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    : _vm._e(),
                  _c("div", {
                    domProps: { innerHTML: _vm._s(_vm.group.instructions) }
                  })
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: { "x-large": "", color: "teal" },
                      on: {
                        click: function($event) {
                          return _vm.finished()
                        }
                      }
                    },
                    [_vm._v("Finished")]
                  ),
                  _c("v-spacer")
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.asset &&
      !_vm.bookingComplete &&
      _vm.group.ils_integration &&
      _vm.group.ils_integration_options.require_patron_login === "true" &&
      !_vm.ilsSignInComplete
        ? _c(
            "v-card",
            { staticClass: "mx-auto", attrs: { "max-width": "700" } },
            [
              _c(
                "v-list-item",
                { attrs: { "two-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", { staticClass: "headline" }, [
                        _vm._v(_vm._s(_vm.$t("assets.pleaseSignIn")))
                      ]),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formattedDate) +
                            " " +
                            _vm._s(_vm.formattedSlot) +
                            " " +
                            _vm._s(_vm.asset.name) +
                            " at " +
                            _vm._s(_vm.asset.location_name) +
                            " "
                        )
                      ])
                    ],
                    1
                  ),
                  _c("v-icon", { attrs: { large: "", right: "" } }, [
                    _vm._v(" schedule ")
                  ])
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-form",
                    {
                      ref: "signinform",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.$tc("global.librarycardnumber", 1),
                                  placeholder: "",
                                  outlined: "",
                                  rules: [_vm.rules.required],
                                  required: ""
                                },
                                model: {
                                  value: _vm.signinform.patronBarcode,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.signinform,
                                      "patronBarcode",
                                      $$v
                                    )
                                  },
                                  expression: "signinform.patronBarcode"
                                }
                              })
                            ],
                            1
                          ),
                          !_vm.clientSettings.client_pinless_auth
                            ? _c(
                                "v-col",
                                { attrs: { cols: "12" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label: _vm.$tc(
                                        "global.librarycardpin",
                                        1
                                      ),
                                      type: "password",
                                      placeholder: "****",
                                      outlined: "",
                                      rules: [_vm.rules.required],
                                      required: ""
                                    },
                                    model: {
                                      value: _vm.signinform.patronPin,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.signinform,
                                          "patronPin",
                                          $$v
                                        )
                                      },
                                      expression: "signinform.patronPin"
                                    }
                                  })
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "teal" },
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.back")))]
                  ),
                  _c("v-spacer"),
                  _vm.submitting
                    ? _c("v-progress-circular", {
                        staticClass: "mr-2",
                        attrs: {
                          indeterminate: true,
                          rotate: 0,
                          size: 32,
                          value: 0,
                          width: 4,
                          color: "teal"
                        }
                      })
                    : _vm._e(),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        disabled: !_vm.valid || _vm.submitting,
                        color: "teal"
                      },
                      on: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.signInToILS(
                            _vm.signinform.patronBarcode,
                            _vm.signinform.patronPin
                          )
                        },
                        click: function($event) {
                          return _vm.signInToILS(
                            _vm.signinform.patronBarcode,
                            _vm.signinform.patronPin
                          )
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.signin")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _vm.asset &&
      !_vm.bookingComplete &&
      (!_vm.group.ils_integration ||
        (!_vm.bookingComplete &&
          _vm.group.ils_integration &&
          _vm.group.ils_integration_options.require_patron_login === "true" &&
          _vm.ilsSignInComplete) ||
        (_vm.group.ils_integration &&
          _vm.group.ils_integration_options.require_patron_login === "false"))
        ? _c(
            "v-card",
            { staticClass: "mx-auto", attrs: { "max-width": "700" } },
            [
              _c(
                "v-list-item",
                { attrs: { "two-line": "" } },
                [
                  _c(
                    "v-list-item-content",
                    [
                      _c("v-list-item-title", { staticClass: "headline" }, [
                        _vm._v("Confirm your booking")
                      ]),
                      _c("v-list-item-subtitle", [
                        _vm._v(
                          " " +
                            _vm._s(_vm.formattedDate) +
                            " " +
                            _vm._s(_vm.formattedSlot) +
                            " " +
                            _vm._s(_vm.asset.name) +
                            " "
                        ),
                        !_vm.asset.is_online
                          ? _c("span", [
                              _vm._v(
                                " at " + _vm._s(_vm.asset.location_name) + " "
                              )
                            ])
                          : _vm._e()
                      ])
                    ],
                    1
                  ),
                  _c("v-icon", { attrs: { large: "", right: "" } }, [
                    _vm._v(" schedule ")
                  ])
                ],
                1
              ),
              _vm.asset.is_mediated
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _c(
                              "div",
                              { staticClass: "mediation-information-box" },
                              [
                                _c("p", { staticClass: "icon" }, [
                                  _c("i", {
                                    staticClass: "fa fa-exclamation-circle",
                                    attrs: { "aria-hidden": "true" }
                                  })
                                ]),
                                _c("div", { staticClass: "box-content" }, [
                                  _c("p", { staticClass: "box-title" }, [
                                    _vm._v("Please note")
                                  ]),
                                  _c("p", { staticClass: "box-message" }, [
                                    _vm._v(
                                      " This booking will require approval. "
                                    )
                                  ])
                                ])
                              ]
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _vm._e(),
              _vm.isVirtual
                ? _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " This is a virtual appointment. Instructions for how to join the call will be sent via email. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                : _c(
                    "v-list-item",
                    [
                      _c(
                        "v-list-item-content",
                        [
                          _c("v-list-item-title", [
                            _vm._v(
                              " This is an in-person appointment, Further instructions will be sent via email. "
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
              _c("v-divider"),
              _c(
                "v-card-text",
                [
                  _vm.group.ils_integration &&
                  _vm.group.ils_integration_options.require_patron_login ===
                    "false"
                    ? _c(
                        "v-form",
                        { ref: "signinform" },
                        [
                          _c(
                            "v-row",
                            [
                              _c(
                                "v-list-item-subtitle",
                                { staticClass: "ml-3 text-wrap" },
                                [
                                  _vm._v(
                                    " " +
                                      _vm._s(
                                        _vm.$t(
                                          "assets.lookupDetailsDescription"
                                        )
                                      ) +
                                      " "
                                  )
                                ]
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        _vm.$tc("global.librarycardnumber", 1) +
                                        " " +
                                        _vm.$t("global.optional"),
                                      placeholder: "",
                                      outlined: ""
                                    },
                                    model: {
                                      value: _vm.signinform.patronBarcode,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.signinform,
                                          "patronBarcode",
                                          $$v
                                        )
                                      },
                                      expression: "signinform.patronBarcode"
                                    }
                                  })
                                ],
                                1
                              ),
                              _c(
                                "v-col",
                                { attrs: { cols: "12", sm: "6" } },
                                [
                                  _c("v-text-field", {
                                    attrs: {
                                      label:
                                        _vm.$tc("global.librarycardpin", 1) +
                                        " " +
                                        _vm.$t("global.optional"),
                                      type: "password",
                                      placeholder: "****",
                                      outlined: ""
                                    },
                                    model: {
                                      value: _vm.signinform.patronPin,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.signinform,
                                          "patronPin",
                                          $$v
                                        )
                                      },
                                      expression: "signinform.patronPin"
                                    }
                                  })
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _c(
                            "v-row",
                            [
                              _c("v-spacer"),
                              _vm.submitting
                                ? _c("v-progress-circular", {
                                    staticClass: "mr-2",
                                    attrs: {
                                      indeterminate: true,
                                      rotate: 0,
                                      size: 32,
                                      value: 0,
                                      width: 4,
                                      color: "teal"
                                    }
                                  })
                                : _vm._e(),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mr-3 white--text",
                                  attrs: {
                                    disabled:
                                      this.form.patronBarcode === "" ||
                                      this.form.patronPin === "",
                                    color: "teal"
                                  },
                                  on: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.signInToILS(
                                        _vm.signinform.patronBarcode,
                                        _vm.signinform.patronPin
                                      )
                                    },
                                    click: function($event) {
                                      return _vm.signInToILS(
                                        _vm.signinform.patronBarcode,
                                        _vm.signinform.patronPin
                                      )
                                    }
                                  }
                                },
                                [_vm._v(_vm._s(_vm.$t("global.lookupDetails")))]
                              )
                            ],
                            1
                          ),
                          _c("v-divider", { staticClass: "mt-2" })
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "v-form",
                    {
                      ref: "form",
                      model: {
                        value: _vm.valid,
                        callback: function($$v) {
                          _vm.valid = $$v
                        },
                        expression: "valid"
                      }
                    },
                    [
                      _c(
                        "v-row",
                        [
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "First name *",
                                  placeholder: "",
                                  outlined: "",
                                  rules: [_vm.rules.required, _vm.rules.name],
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.firstName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "firstName", $$v)
                                  },
                                  expression: "form.firstName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12", sm: "6" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: "Last name *",
                                  placeholder: "",
                                  outlined: "",
                                  rules: [_vm.rules.required, _vm.rules.name],
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.lastName,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "lastName", $$v)
                                  },
                                  expression: "form.lastName"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.group.email_required
                                    ? "Email address *"
                                    : "Email address",
                                  placeholder: "email@address.com",
                                  outlined: "",
                                  type: "email",
                                  rules: _vm.group.email_required
                                    ? [_vm.rules.required, _vm.rules.email]
                                    : [_vm.rules.email],
                                  required: ""
                                },
                                model: {
                                  value: _vm.form.email,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "email", $$v)
                                  },
                                  expression: "form.email"
                                }
                              })
                            ],
                            1
                          ),
                          _c(
                            "v-col",
                            { attrs: { cols: "12" } },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  label: _vm.group.cell_required
                                    ? "Cell # *"
                                    : "Cell #",
                                  rules: _vm.group.cell_required
                                    ? [_vm.rules.required, _vm.rules.cell]
                                    : [_vm.rules.cell],
                                  required: "",
                                  placeholder: "111-111-1111",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.form.cell,
                                  callback: function($$v) {
                                    _vm.$set(_vm.form, "cell", $$v)
                                  },
                                  expression: "form.cell"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm.group.custom_fields.fields
                        ? _c(
                            "v-row",
                            _vm._l(_vm.group.custom_fields.fields, function(
                              field,
                              index
                            ) {
                              return _c(
                                "v-col",
                                { key: index, attrs: { cols: "12" } },
                                [
                                  field.type === "text"
                                    ? _c("v-text-field", {
                                        attrs: {
                                          label: _vm.getTitle(field),
                                          messages: field.helpText || "",
                                          rules: _vm.getRules(field),
                                          outlined: ""
                                        },
                                        model: {
                                          value: _vm.form[field.name],
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, field.name, $$v)
                                          },
                                          expression: "form[field.name]"
                                        }
                                      })
                                    : _vm._e(),
                                  field.type === "textarea"
                                    ? _c("v-textarea", {
                                        attrs: {
                                          label: _vm.getTitle(field),
                                          messages: field.helpText || "",
                                          rules: _vm.getRules(field),
                                          outlined: ""
                                        },
                                        model: {
                                          value: _vm.form[field.name],
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, field.name, $$v)
                                          },
                                          expression: "form[field.name]"
                                        }
                                      })
                                    : _vm._e(),
                                  field.type === "checkbox"
                                    ? _c("v-checkbox", {
                                        attrs: {
                                          label: _vm.getTitle(field),
                                          messages: _vm.getCheckboxMessages(
                                            field
                                          ),
                                          rules: _vm.getRules(field),
                                          outlined: ""
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "message",
                                              fn: function() {
                                                return [
                                                  _vm.hasFieldLink(field)
                                                    ? _c(
                                                        "a",
                                                        {
                                                          attrs: {
                                                            href: field.link
                                                          }
                                                        },
                                                        [
                                                          _vm._v(
                                                            " " +
                                                              _vm._s(
                                                                _vm.getLinkText(
                                                                  field
                                                                )
                                                              ) +
                                                              " "
                                                          )
                                                        ]
                                                      )
                                                    : _vm.hasFieldHelpText(
                                                        field
                                                      )
                                                    ? _c("p", [
                                                        _vm._v(
                                                          " " +
                                                            _vm._s(
                                                              field.helpText
                                                            ) +
                                                            " "
                                                        )
                                                      ])
                                                    : _vm._e()
                                                ]
                                              },
                                              proxy: true
                                            }
                                          ],
                                          null,
                                          true
                                        ),
                                        model: {
                                          value: _vm.form[field.name],
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, field.name, $$v)
                                          },
                                          expression: "form[field.name]"
                                        }
                                      })
                                    : _vm._e(),
                                  field.type === "select"
                                    ? _c("v-select", {
                                        attrs: {
                                          items: field.options.split("\n"),
                                          label: _vm.getTitle(field),
                                          messages: field.helpText || "",
                                          rules: _vm.getRules(field),
                                          outlined: ""
                                        },
                                        model: {
                                          value: _vm.form[field.name],
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, field.name, $$v)
                                          },
                                          expression: "form[field.name]"
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              )
                            }),
                            1
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c("v-divider"),
              _c(
                "v-card-actions",
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { outlined: "", color: "teal" },
                      on: {
                        click: function($event) {
                          return _vm.$router.go(-1)
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.back")))]
                  ),
                  _c("v-spacer"),
                  _c(
                    "v-btn",
                    {
                      staticClass: "white--text",
                      attrs: {
                        disabled: !_vm.valid || _vm.submitting,
                        color: "teal"
                      },
                      on: {
                        click: function($event) {
                          return _vm.submitBooking()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("global.confirm")))]
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e(),
      _c(
        "v-snackbar",
        {
          attrs: { timeout: _vm.timeout },
          model: {
            value: _vm.showError,
            callback: function($$v) {
              _vm.showError = $$v
            },
            expression: "showError"
          }
        },
        [
          _vm._v(" " + _vm._s(_vm.errorMessage) + " "),
          _c(
            "v-btn",
            {
              attrs: { color: "blue", text: "" },
              on: {
                click: function($event) {
                  _vm.showError = false
                }
              }
            },
            [_vm._v(" Close ")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }